import * as React from 'react'

import { InputText as InputTextPresenter, IProps } from './presenter'

export const InputText = React.forwardRef<HTMLInputElement, IProps>(
  (props, ref) => <InputTextPresenter {...props} ref={ref} />,
)

export default InputText
